export default __webpack_public_path__ + "static/ollama-6e36ff18469bffba933eb7d7f9f0ccf4.png";